export const CATEGORY_META = {
  AUTOMATION: { label: "Automation", color: "var(--color-primary)" },
  COMMUNICATIONAL: { label: "Communication", color: "var(--color-info)" },
  CLIENT: { label: "Client", color: "var(--color-secondary)" },
};

export const TYPE_META = {
  BULK: { label: "Bulk", color: "var(--color-primary)" },
  SINGLE: { label: "Single", color: "var(--color-secondary)" },
};

export const STATUS_META = {
  PENDING: { label: "Pending", color: "var(--color-warning)" },
  SCHEDULED: { label: "Scheduled", color: "var(--color-info)" },
  SENT: { label: "Sent", color: "var(--color-primary)" },
  DELIVERED: { label: "Delivered", color: "var(--color-secondary)" },
  READ: { label: "Read", color: "var(--color-success)" },
  FAILED: { label: "Failed", color: "var(--color-danger)" },
};

export const EMAIL_TYPE_META = {
  AUTH: { label: "Authentication", color: "var(--color-primary)" },
  PROJECT_NOTIFICATION: { label: "Project Notification", color: "var(--color-secondary)" },
  OTHER: { label: "Other", color: "var(--color-text-muted)" },
  HELP: { label: "Help & Support", color: "var(--color-info)" },
  CHAT_MESSAGE: { label: "Chat Message", color: "var(--color-warning)" },
  RESET_PASSWORD_OTP: { label: "Password Reset OTP", color: "var(--color-high)" },
  REMINDER: { label: "Reminder", color: "var(--color-success)" },
};

export const RANGE_OPTIONS = [
  { value: 7, label: "7D" },
  { value: 30, label: "30D" },
  { value: 90, label: "90D" },
];

export const fmtCompact = (n) => {
  const num = Number(n) || 0;
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(1)}k`;
  return `${num}`;
};

export const fmtDate = (iso, opts) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-GB", opts || { day: "2-digit", month: "short" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};
